import { MutationTree } from 'vuex'

import _get from 'lodash/get'
import _find from 'lodash/find'
import _findIndex from 'lodash/findIndex'
import _keys from 'lodash/keys'

import { OfferCartsState } from './types'
import { state as initialState } from './index'
import { Seller, Offer, OfferItem } from '../../types'

export const mutations: MutationTree<OfferCartsState> = {
  reset(state) {
    Object.keys(initialState).forEach(key => {
      state[key] = initialState[key]
    })
  },

  resetRequest(state) {
    state.addOfferItemRequired = null
    state.addedOfferItem = false
    state.deletingOfferItemIds = []
    state.updatingOfferItemIds = []
    Object.keys(initialState).forEach(key => {
      if (key.indexOf('request') === 0 || key === 'error') {
        state[key] = initialState[key]
      }
    })
  },

  setActiveOffer(state, payload: { offer: Offer | null }) {
    state.activeOffer = payload.offer
    state.requestUploadInventoryList = false
    state.addOfferItemRequired = null
  },

  setAddOfferItemRequired(state, payload: OfferItem | null) {
    state.addOfferItemRequired = payload
  },

  setAddedOfferItem(state, payload: boolean) {
    state.addedOfferItem = payload
    setTimeout(() => {
      state.addedOfferItem = false
    }, 5000)
  },

  offerCompleted(state, payload: { prevOfferId: string; offer: Offer }) {
    state.requestPostOfferComplete = false
    state.activeOffer = payload.offer
  },

  offerRevised(state, payload: { prevOfferId: string; offer: Offer }) {
    state.requestPostOfferRevise = false
    state.activeOffer = payload.offer
  },

  putOfferItem(state, payload: { offerItemId: string }) {
    if (!_get(payload, ['offerItemId'])) return
    state.updatingOfferItemIds = state.updatingOfferItemIds.filter(id => id !== payload.offerItemId)
  },

  deleteOfferItem(state, payload: string) {
    state.deletingOfferItemIds = state.deletingOfferItemIds.filter(id => id !== payload)
  },

  setError(state, payload) {
    state.addedOfferItem = false
    state.requestPostOffer = false
    state.requestDeleteOffer = false
    state.requestPostOfferItem = false
    state.requestPostOfferComplete = false
    state.requestUploadInventoryList = false
    state.error = payload
  },

  setRequestPostOffer(state, payload: boolean) {
    state.requestPostOffer = payload
    state.error = null
  },

  setRequestDeleteOffer(state, payload: boolean) {
    state.requestDeleteOffer = payload
    state.error = null
  },

  setRequestPostOfferItem(state, payload: boolean) {
    state.requestPostOfferItem = payload
    state.error = null
  },

  setRequestPutOfferItem(state, payload: string) {
    state.updatingOfferItemIds = [...state.updatingOfferItemIds, payload]
    state.error = null
  },

  setRequestDeleteOfferItem(state, payload: string) {
    state.deletingOfferItemIds = [...state.deletingOfferItemIds, payload]
    state.error = null
  },

  setFailedPutOfferItem(state, payload: string) {
    state.updatingOfferItemIds = state.updatingOfferItemIds.filter(id => id !== payload)
  },

  setFailedDeleteOfferItem(state, payload: string) {
    state.deletingOfferItemIds = state.deletingOfferItemIds.filter(id => id !== payload)
  },

  setRequestPostOfferComplete(state, payload: boolean) {
    state.requestPostOfferComplete = payload
    state.error = null
  },

  setRequestPostOfferRevise(state, payload: boolean) {
    state.requestPostOfferRevise = payload
    state.error = null
  },

  setUploadInventoryListRequired(state, payload: File | null) {
    state.uploadInventoryListRequired = payload
  },

  setRequestUploadInventoryList(state, payload: boolean) {
    state.requestUploadInventoryList = payload
    state.error = null
  },
}
